import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles({
  defaultLogoContainer: {
    backgroundColor: colors.gray.l96,
    '& > div': {
      fontSize: '4.4rem',
      lineHeight: '5.3rem',
      fontWeight: 700,
    },
  },
  logo: {
    objectFit: 'contain',
    backgroundColor: colors.gray.l96,
    height: '100%',
    width: '100%',
  },
});
